var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:[_vm.buttonClasses, _vm.cssClasses],attrs:{"to":_vm.to,"outlined":_vm.outlined,"loading":_vm.loading ? _vm.loading : false,"elevation":_vm.elevation}},'v-btn',_vm.attrs,false),_vm.action ? { click: _vm.action } : { click: () => _vm.$emit('click') }),[_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }